import { Divider, Heading } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'

interface SectionHeaderProps {
  title: string
}

export const SectionHeader: FunctionComponent<SectionHeaderProps> = ({ title }): JSX.Element | null => {
  const { sectionHeadingSize } = useCheckoutSizes()

  return (
    <>
      <Divider kind='Hairline' margin='Regular' />
      <div className={styles.headerContainer}>
        <Heading size={sectionHeadingSize}>{title}</Heading>
      </div>
    </>
  )
}
